var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUnitPlaceholder = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 76,
  height: 62,
  style: {
    background: "#14202c"
  },
  viewBox: "0 0 76 62"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#69728B",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M2 44v14h14V44zm0-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V44a2 2 0 0 1 2-2m29 2v14h14V44zm0-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H31a2 2 0 0 1-2-2V44a2 2 0 0 1 2-2m29 2v14h14V44zm0-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H60a2 2 0 0 1-2-2V44a2 2 0 0 1 2-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M66 32H39v10h-2V32H10v12H8V30h29V20h2v10h29v14h-2z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M31 4v14h14V4zm0-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H31a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2"
}))));
export default SvgUnitPlaceholder;